import { useRef, useEffect } from "react";
import ProjectCard from "./ProjectCard";
import DiscordBot from '../assets/images/Wangusbot.png';
import Smokeplus from '../assets/images/Smokeplus.png';
import PlaylistCrusader from '../assets/images/PlaylistCrusader.png';
import Calculator from '../assets/images/Calculator.png';
import PokeTeamBuilder from '../assets/images/PokeTeamBuilder.png';
import Portfolio from '../assets/images/Portfolio.png';

const Projects = () => {
  const scrollerRef = useRef(null);
  const scrollTimeout = useRef();

  useEffect(()=>{
    centerNearestCard();
  },[])

  const projects = [
    {
      title: "Playlist Crusader",
      image: PlaylistCrusader,
      tech: "ReactJS • Java",
      description: "Music Playlist Social Platform",
      extra: "Fully customizable playlists with like functionality",
      link: "https://github.com/lzklein/playlist-crusaders"
    },
    {
      title: "This Website",
      image: Portfolio,
      tech: "ReactJS • Spring Boot",
      description: "Production-deployed full-stack portfolio",
      extra: "Secure custom email handling, self-hosted backend with Nginx and Cloudflare",
      link: "https://github.com/lzklein/portfolio"
    },
    {
      title: "SmokePlus Online Storefront",
      image: Smokeplus,
      tech: "ReactJS • ExpressJS",
      description: "Set up pickup orders",
      extra: "Manage inventory as an employee",
      link: "https://smokeplus.onrender.com/",
    },
    {
      title: "WangusBot",
      image: DiscordBot,
      tech: "DiscordJS",
      description: "Discord Music Bot",
      extra: "Downloads and plays audio via YouTube link",
      link: "https://github.com/lzklein/Wangus-Bot-II"
    },
    {
      title: "BitCalculator",
      image: Calculator,
      tech: "C++",
      description : "Calculator app built in C++",
      extra: "GUI built using SFML library and self drawn assets",
      link: "https://github.com/lzklein/calculator"
    },
    {
      title: "Poké Team Builder",
      image: PokeTeamBuilder,
      tech: "ReactJS",
      description : "Pokémon team building, customization, analysis tool",
      extra: "Powered by PokeAPI",
      link: "https://github.com/lzklein/poke-teambuilder"
    },
  ];

  const handleScroll = () => {
    if (scrollTimeout.current) clearTimeout(scrollTimeout.current);

    // 150ms after last input
    scrollTimeout.current = setTimeout(() => {
      centerNearestCard();
    }, 150);
  };

  const centerNearestCard = () => {
    const container = scrollerRef.current;
    const cards = container.querySelectorAll(".project-card");

    const containerCenter = container.scrollLeft + container.offsetWidth / 2;

    let closestCard = null;
    let closestDistance = Infinity;

    cards.forEach((card) => {
      const cardCenter = card.offsetLeft + card.offsetWidth / 2;
      const distance = Math.abs(containerCenter - cardCenter);
      if (distance < closestDistance) {
        closestDistance = distance;
        closestCard = card;
      }
    });

    if (closestCard) {
      const cardCenter = closestCard.offsetLeft + closestCard.offsetWidth / 2;
      const scrollTo = cardCenter - container.offsetWidth / 2;

      container.scrollTo({
        left: scrollTo,
        behavior: "smooth",
      });
    }
  };

  return (
    <div className="page">
      <h2>My Projects</h2>
      <div
        className="projects-carousel"
        ref={scrollerRef}
        onScroll={handleScroll}   // attach scroll listener
      >

        <div className="carousel-spacer" />

        {projects.map((project, ind)=>{
          return <ProjectCard key={ind} {...project}/>
        })}

        <div className="carousel-spacer" />
      </div>
    </div>
  );
};

export default Projects;
